import * as React from "react";
import { UitkCardMedia } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { inject } from "mobx-react";
import { NeighborhoodCardMediaProps } from "../typings";
import { EntityType, HeartButton } from "components/shared/HeartButton/HeartButton";
import { MediaAttribution } from "components/utility/MediaAttributionUtil";
import { LazyLoadedImage } from "components/utility/LazyLoadedImage/LazyLoadedImage";

export const NeighborhoodCardMedia = inject("thumbor")((props: NeighborhoodCardMediaProps) => {
  const neighborhoodImageUrl: string =
    props.thumbor && props.media.mediaUrl
      ? props.thumbor.safelyGenerateThumborizedImageUrl(props.media.mediaUrl, 350, 192, props.context, undefined, true)
      : "";

  const attribution =
    props.attributionType === "destination"
      ? MediaAttribution(props.media, props.regionName)
      : MediaAttribution(props.media, props.regionName, props.renderAttributionText);

  return (
    <UitkCardMedia>
      <UitkFigure ratio={props.ratio || UitkFigureAspectRatioType.R16_9}>
        <LazyLoadedImage src={neighborhoodImageUrl} alt={attribution?.attributionAltText} offset={125} />
        {attribution?.attributionText}
        {props.showFavorite && (
          <HeartButton
            moduleName={"TG.LP.Dest.Neighborhoods"}
            heartableEntity={{
              id: props.id,
              name: props.regionName,
              entityType: EntityType.NEIGHBORHOOD,
              payload: { favoriteId: props.id },
            }}
          />
        )}
      </UitkFigure>
    </UitkCardMedia>
  );
});
